export enum PageFit {
  WIDTH = "width",
  HEIGHT = "height",
}

export enum PageLayout {
  SINGLE = "single",
  DOUBLE = "dps",
  FACING = "facing",
}
